import { Link } from "react-router-dom";
import { TrendingDown, CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";

const Unsubscribed = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center">
      {/* Noise overlay */}
      <div className="noise-overlay"></div>
      
      <div className="text-center px-6 max-w-lg">
        <div className="w-16 h-16 rounded-full bg-[#D4F34A]/20 flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-8 h-8 text-[#D4F34A]" />
        </div>
        
        <h1 className="font-heading text-3xl font-bold tracking-tight mb-4">
          You've Been Unsubscribed
        </h1>
        
        <p className="text-text-muted mb-8">
          You will no longer receive weekly profit leak reports via email. 
          You can always re-enable email reports in your dashboard settings.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/dashboard">
            <Button
              className="bg-[#D4F34A] text-black hover:bg-[#D4F34A]/90 font-bold rounded-full px-6 py-3"
              data-testid="goto-dashboard-btn"
            >
              Go to Dashboard <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
          
          <Link to="/">
            <Button
              variant="outline"
              className="bg-white/10 text-white hover:bg-white/20 border border-white/10 rounded-full px-6 py-3"
            >
              Back to Home
            </Button>
          </Link>
        </div>
        
        {/* Logo */}
        <div className="mt-16 flex items-center justify-center gap-2 text-text-muted">
          <div className="w-6 h-6 rounded bg-[#D4F34A] flex items-center justify-center">
            <TrendingDown className="w-4 h-4 text-black" />
          </div>
          <span className="font-heading font-semibold">ReplyDriven</span>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribed;
